import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import { Card, CardText } from 'material-ui';
import _ from 'lodash';
import moment from 'moment';
import Translate from 'translate';

import IncmsService from 'services/IncmsService'
import { Text } from 'components/FormElements/';
import { toggleLoading } from 'stores/actions/';

class SearchIncmsModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      submitted: false,
      phone: "",
    };

    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if ( nextProps.open && !this.props.open ) {
      this.setState( { data: [], submitted: false } )
    }
  }

  submitForm( data ) {
    //console.log(data,"data")
    this.props.toggleLoading( true );

    let filterParams = {};
    _.map( data, ( value, filter ) => {
      if ( value ) filterParams[`filters[${filter}]`] = value;
    } );

    IncmsService.searchProfile( filterParams ).then( ( response ) => {
      if ( response.data ) this.setState( { data: response.data, submitted: true } );
      else this.setState( {
        submitted: true ,
        phone:"",
        account:"",
        meterNumber: "",
        documentNumber: "",
        legacyRef: "",
        rccs: "",
        imsRef: "",
        workReq: ""
      } );
      this.props.toggleLoading( false );
    } )
  }

  render() {
    //console.log(this.state,"state")
    const { onSelectCard, onClose, open, externalCodes, channel, externalCustomer } = this.props;
    const {phone, account, meterNumber, documentNumber, legacyRef, rccs, imsRef, workReq} = this.state;
    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="modal-search-incms col-md-8"
             open={open}
             onClose={() => {
               this.setState( { data: [] } );
               //console.log(this.state,"state2")
               onClose()
             }}>
        <h5 className="mt-0"><Translate id="search"/> </h5>

        <Form onSubmit={this.submitForm}
          defaultValues={{ 
            phone: phone,
            account: account,
            meterNumber: meterNumber,
            documentNumber: documentNumber,
            legacyRef: legacyRef,
            rccs: rccs,
            imsRef: imsRef,
            workReq: workReq
          }}
        >
          {( { getValue, submitForm } ) =>
            <form onSubmit={submitForm} className="mt-4">
              <div className="row mb-3">
                <div className="col-6">
                  <Text field="account"
                        onChange={( value ) => {  this.setState( { account: value }) }}
                        placeholder="incmsAccountReference"
                        className="form-control"/>
                </div>
                <div className="col-6 pl-0">
                  <Text field="meterNumber"
                        onChange={( value ) => {  this.setState( { meterNumber: value }) }}
                        placeholder="meterSerialNumber"
                        className="form-control"/>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-6">
                  <Text field="documentNumber"
                        onChange={( value ) => {  this.setState( { documentNumber: value }) }}
                        placeholder={externalCodes ? 'nationalNumber' : 'documentNumber' }
                        className="form-control"/>
                </div>
                
                <div className="col-6 pl-0">
                  <Text field="phone" placeholder="customerPhone"
                        onChange={( value ) => {  this.setState( { phone: value }) }}
                        className="form-control"/>
                </div>
                
              </div>

              <div className="row">
                <div className="col-6">
                  <Text field="rccs"
                        onChange={( value ) => {  this.setState( { rccs: value }) }}
                        placeholder={externalCustomer === 'kplc' ? 'incidence' : 'RCCS'}
                        className="form-control"/>
                </div>

                <div className="col-6 pl-0">
                  <Text field="workReq" placeholder="wr"
                        onChange={( value ) => {  this.setState( { workReq: value }) }}
                        className="form-control"/>
                </div>
              </div>

              <div className= "row mt-3">
                <div className="col-6">
                  <Text field="imsRef" placeholder="IMSreference"
                        onChange={( value ) => {  this.setState( { imsRef: value }) }}
                        className="form-control"/>
                </div>

                <div className="col-6 pl-0">
                  <Text field="legacyRef" placeholder="Legacy"
                        onChange={( value ) => {  this.setState( { legacyRef: value }) }}
                        className="form-control"/>
                </div>
              </div>
              <hr/>
              <div className="text-right">
                <button className="btn btn-info"
                        disabled={!getValue( 'documentNumber' ) && !getValue( 'phone' ) && !getValue( 'account' ) && !getValue( 'meterNumber' ) && !getValue( 'legacyRef' )&& !getValue( 'rccs' )&& !getValue( 'workReq' )&& !getValue( 'imsRef' )}>
                  <Translate id="submit"/>
                </button>
              </div>
            </form>
          }
        </Form>

        <div className="row content mt-3">
          {_.map( this.state.data, ( item, index ) =>
            <div key={index} className="col-md-6 mt-1 mb-3">
              <Card containerStyle={{ cursor: 'pointer' }} onClick={() => {
                onClose();
                onSelectCard( item )
              }}>
                <CardText>
                  <div className="col-md-12 p-0">
                    <div className="row">
                      <div className="col-md-3"><Translate id="name"/></div>
                      <div className="col-md-9 text-small text-muted">{item.fullName}</div>
                    </div>

                    <div className="row">
                      <div className="col-md-3"><Translate id="email"/></div>
                      <div className="col-md-9 text-small text-muted">{item.email || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="phone"/></div>
                      <div className="col-md-9 text-small text-muted">{item.phone || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="account"/></div>
                      <div className="col-md-9 text-small text-muted">{item.account || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="status"/></div>
                      <div className="col-md-9 text-small text-muted">{item.accountStatus || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="location"/></div>
                      <div className="col-md-9 text-small text-muted">{item.location || '---'}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="doc"/></div>
                      <div className="col-md-9 text-small text-muted">
                        {item.docNumber ? `#${item.docNumber}` : '---'}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="supply"/></div>
                      <div className="col-md-9 text-small text-muted">
                        {item.supplyNumber ? `#${item.supplyNumber}` : '---'} 
                        {item.contractMask &&
                           item.contractMask === 2048  ? ` (Prepaid) ` : ' (Postpaid) '
                        }
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3"><Translate id="meter"/></div>
                      <div className="col-md-9 text-small text-muted">
                        {item.meterNumber ? `#${item.meterNumber}` : '---'}
                      </div>
                    </div>

                  </div>
                </CardText>
              </Card>
            </div>
          )}

          {this.state.submitted && !this.state.data.length &&
          <div className="col-md-12 text-center">
            <h4 className="text-muted mt-0"><Translate id="noDataFound"/></h4>
          </div>
          }
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  externalCodes: state.settings.externalCodes,
  externalCustomer: state.settings.externalCustomer,
} );

const mapDispatchToProps = dispatch => ({
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( SearchIncmsModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/SearchIncmsModal/index.js